var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"UnitOwnerList_main"}},[_c('div',{staticClass:"main"},[_vm._m(0),_c('RegisterList',{attrs:{"show-filter":true,"show-conrtol-wrap":true,"show-button":false,"display-mode":1,"show-registration":true}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_bar"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v("\n          出席名單\n        ")])])])
}]

export { render, staticRenderFns }